import { combineReducers } from 'redux';
import regions from './regions';
import areas from './areas';
import cities from './cities';
import localities from './localities';
import domains from './domains';
import streets from './streets';

export default combineReducers({
  regions,
  areas,
  cities,
  localities,
  domains,
  streets
});

export * from './regions';
export * from './areas';
export * from './cities';
export * from './localities';
export * from './domains';
export * from './streets';



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/index.js